import React from 'react';

const testimonials = [
  {
    photo: 'https://randomuser.me/api/portraits/men/32.jpg',
    quote: 'A plataforma revolucionou a forma como gerenciamos nossos projetos. A eficiência aumentou significativamente!',
    author: 'João Silva',
    title: 'Secretário de Planejamento',
    org: 'Governo do Estado',
    stars: 5,
  },
  {
    photo: 'https://randomuser.me/api/portraits/women/44.jpg',
    quote: 'Com a centralização de dados, tomamos decisões muito mais rápidas e assertivas. Essencial para a nossa gestão.',
    author: 'Maria Oliveira',
    title: 'Prefeita Municipal',
    org: 'Prefeitura Municipal',
    stars: 5,
  },
  {
    photo: 'https://randomuser.me/api/portraits/men/65.jpg',
    quote: 'O suporte é excelente e a ferramenta é extremamente intuitiva. Recomendo a todos os gestores públicos.',
    author: 'Carlos Santos',
    title: 'Diretor de TI',
    org: 'Câmara Municipal',
    stars: 5,
  },
];

const Stars = () => (
  <div className="flex gap-0.5 mb-4">
    {[...Array(5)].map((_, i) => (
      <svg key={i} className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" style={{ color: '#F47920' }}>
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
      </svg>
    ))}
  </div>
);

const TestimonialsSection = () => (
  <section className="py-24 bg-white">
    <div className="container mx-auto px-6 md:px-12">
      <div className="text-center mb-16">
        <div className="inline-flex items-center gap-2.5 mb-4 justify-center">
          <span className="w-1 h-4" style={{ background: '#F47920' }} />
          <span className="text-xs font-bold uppercase tracking-widest" style={{ color: '#F47920' }}>
            Depoimentos
          </span>
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 tracking-tight">
          O que nossos clientes dizem
        </h2>
        <p className="text-gray-500 max-w-xl mx-auto">
          Gestores públicos que já transformaram sua administração com a Nexus.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {testimonials.map((t, i) => (
          <div
            key={i}
            className="bg-white border border-gray-200 rounded-xl p-8 hover:shadow-md transition-all duration-200 flex flex-col"
          >
            <Stars />
            <p className="text-gray-700 leading-relaxed mb-6 flex-1 text-sm">
              "{t.quote}"
            </p>
            <div className="flex items-center gap-4 pt-4 border-t border-gray-100">
              <img
                src={t.photo}
                alt={t.author}
                className="w-11 h-11 rounded-full object-cover ring-2 ring-white shadow-sm"
              />
              <div>
                <p className="font-bold text-gray-900 text-sm">{t.author}</p>
                <p className="text-gray-400 text-xs">{t.title} · {t.org}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TestimonialsSection;
